<div class="row mt-5">
    <div class="col-md-12 ">
        <nav>
            <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">

                <a class="nav-item nav-link" *ngIf="visibleTabs['vision']" [class.active]="activeTab === 'vision'"
                    (click)="switchTab('vision', 'nav-vision')" role="tab" aria-selected="false">
                    <i class="fas fa-eye fa-3x d-block"></i><span class="d-none d-sm-block">Vision</span>
                </a>
                <a class="nav-item nav-link" *ngIf="visibleTabs['lasik']" [class.active]="activeTab === 'lasik'"
                    (click)="switchTab('lasik', 'nav-lasik')" role="tab" aria-selected="false">
                    <i class="fas fa-low-vision fa-3x d-block"></i><span class="d-none d-sm-block">LASIK</span>
                </a>
                <a class="nav-item nav-link" *ngIf="visibleTabs['hearing']" [class.active]="activeTab === 'hearing'"
                    (click)="switchTab('hearing', 'nav-hearing')" role="tab" aria-selected="false">
                    <i class="fas fa-low-vision fa-3x d-block"></i><span class="d-none d-sm-block">Hearing</span>
                </a>
                <a class="nav-item nav-link" *ngIf="visibleTabs['urgentcare']" [class.active]="activeTab === 'urgentcare'"
                    (click)="switchTab('urgentcare', 'nav-urgentcare')" role="tab" aria-selected="false">
                    <i class="fas fa-prescription-bottle-alt fa-3x d-block"></i><span class="d-none d-sm-block">Urgent
                        Care</span>
                </a>
                <a class="nav-item nav-link" *ngIf="visibleTabs['therapy']" [class.active]="activeTab === 'therapy'"
                    (click)="switchTab('therapy', 'nav-therapy')" role="tab" aria-selected="false">
                    <i class="fas fa-prescription-bottle-alt fa-3x d-block"></i><span
                        class="d-none d-sm-block">Therapy</span>
                </a>
                <a class="nav-item nav-link" *ngIf="visibleTabs['prescriptions']" [class.active]="activeTab === 'prescriptions'"
                    (click)="switchTab('prescriptions', 'nav-prescriptions')" role="tab" aria-selected="false">
                    <i class="fas fa-prescription-bottle-alt fa-3x d-block"></i><span
                        class="d-none d-sm-block">Prescriptions</span>
                </a>
            </div>
        </nav>
        <div class="tab-content py-3 px-3 px-sm-0" id="nav-tabContent">
            <div class="tab-pane fade" *ngIf="visibleTabs['vision']" [class.show]="activeTab === 'vision'" [class.active]="activeTab === 'vision'"
                id="nav-vision" role="tabpanel">
                <h2>Vision Care</h2>
                <img class="prod-image" src="assets/images/EyeMed.jpg" alt="EyeMed logo" />
                <ul>
                    <li>Members save 20% to 40% off the retail price of eyewear with the EyeMed Vision Care Access Plan
                        D discount program through the Access network. Members are eligible for discounts on exams,
                        eyeglasses and contact lenses from more than 90,000 providers nationwide including independent
                        optometrists, ophthalmologists, opticians and leading optical retailers such as LensCrafters®,
                        Sears Optical®, Target Optical®, JCPenney® Optical and most Pearle Vision® locations.</li>
                </ul>
                <small>
                    <p>EYEM - 11/2/17</p>
                </small>
            </div>

            <div class="tab-pane fade" *ngIf="visibleTabs['lasik']" [class.show]="activeTab === 'lasik'" [class.active]="activeTab === 'lasik'"
                id="nav-lasik" role="tabpanel">
                <h2>LASIK Vision Correction</h2>
                <img class="prod-image" src="assets/images/QualSight.jpg" alt="Qualsight Logo" />
                <p>QualSight provides discounts on traditional Lasik surgery. With over 800 locations, you can choose a
                    physician with the experience, reputation and technology your vision correction requires. QualSight
                    offers one low price that includes the preoperative exam, procedure and postoperative visits. For
                    details, call QualSight at 866.244.0470 or <a href="//www.qualsight.com"
                        target="_blank">www.qualsight.com</a></p>
                <small>
                    <p>QSTP - 7/21/15</p>
                </small>
            </div>

            <div class="tab-pane fade" *ngIf="visibleTabs['hearing']" [class.show]="activeTab === 'hearing'" [class.active]="activeTab === 'hearing'"
                id="nav-hearing" role="tabpanel">
                <h2>Hearing</h2>
                <img class="prod-image" src="assets/images/amplifon.jpg" alt="Amplifon Logo" />
                <ul>
                    <li>Members can save 35% to 70% off MSRP on most hearing aids purchased through an Amplifon Hearing
                        Health Care network provider.</li>
                    <li>1 year follow-up care which includes cleaning, adjustment, and other hearing aid services.</li>
                    <li>2 years of free batteries (80 cells per hearing aid, per year) mailed directly to your home or
                        one standard recharging station</li>
                </ul>
                <p>HRPO - 10/4/22</p>
            </div>

            <div class="tab-pane fade" *ngIf="visibleTabs['prescriptions']" [class.show]="activeTab === 'prescriptions'"
                [class.active]="activeTab === 'prescriptions'" id="nav-prescriptions" role="tabpanel">
                <h2>Prescriptions</h2>
                <img class="prod-image" src="assets/images/elixir.gif" alt="Envision Savings Logo" />
                <ul>
                    <li>Members will save between 15% to 60% on generic drugs and 15% to 25% on brand name drugs at over
                        60,000 participating pharmacies nationwide including Safeway, CVS, Wal-Mart, Walgreens and Rite
                        Aid.</li>
                    <li>Members have access to an interactive website that allows users to locate the nearest
                        participating pharmacy and accurately check the current costs of drugs, thereby ensuring members
                        always receive the lowest prices and greatest value.</li>
                </ul>
                <p><a class="btn btn-lg btn-primary" href="https://www.emsmed.com/vendors/rxpricing.aspx" role="button"
                        target="_blank">Check RX Prices</a></p>
                <p>ENVC - 10/26/18</p>
            </div>

            <div class="tab-pane fade" *ngIf="visibleTabs['urgentcare']" [class.show]="activeTab === 'urgentcare'"
                [class.active]="activeTab === 'urgentcare'" id="nav-urgentcare" role="tabpanel">
                <h2>Urgent Care - A DialCare Physician Access Product</h2>
                <div>
                    <div>
                        <div class="PRODUCT">
                            
                            <img src="assets/images/dc-urgent-care.jpg"
                                alt="DialCare Urgent Care Logo" class="pull-right float-right d-inline-block"
                                width="200" height="200">
                            <p>DialCare Urgent Care is a modern, easy-to-use telemedicine solution for non-emergency
                                illnesses and general care. Members and their families have direct access to
                                state-licensed, fully credentialed physicians via phone or video consultations to
                                receive treatment and advice for common ailments, including colds, the flu, rashes and
                                more. When medically appropriate, a DialCare physician may prescribe a short-term,
                                non-DEA controlled medication for the member to pick up at the pharmacy of their choice.
                            </p>
                            <p>Physicians are available 24 hours a day, 365 days a year, allowing members and their
                                families convenient access to quality care from home, work or on the go.</p>
                            <h3>When to use Urgent Care:</h3>
                            <ul>
                                <li>For non-emergency medical issues and questions</li>
                                <li>During or after normal business hours, nights, weekends and holidays</li>
                                <li>If the member lives a significant distance from a primary care doctor</li>
                                <li>When a primary care doctor is not available</li>
                                <li>When traveling in the U.S. and in need of non-urgent medical care or advice</li>
                            </ul>
                            <h3>What conditions can be treated? </h3>
                            <ul>
                                <li>Allergies</li>
                                <li>Fever</li>
                                <li>Respiratory infections</li>
                                <li>Asthma</li>
                                <li>Gout</li>
                                <li>Sinus infections</li>
                                <li>Bronchitis</li>
                                <li>Insect bites</li>
                                <li>Skin inflammations</li>
                                <li>Cold and flu</li>
                                <li>Sore throat</li>
                                <li>Digestive issues</li>
                                <li>Joint aches and pains</li>
                                <li>Sports injuries</li>
                                <li>Ear infections</li>
                                <li>Rashes</li>
                                <li>Urinary tract infections</li>
                                <li>And more!</li>
                            </ul>
                            <p><em><strong>State availability may vary. Please visit <a
                                            href="https://dialcare.com/states" target="_blank"
                                            title="This link will open in a new window."
                                            rel="noopener noreferrer">dialcare.com/states</a> for up-to-date
                                        information.<br>
                                        A consult fee of $65.00 applies to all consults.<br>
                                        Consultations are available in English and Spanish.<br>
                                        Urgent Care is a part of the DialCare Physician Access Program.</strong></em>
                            </p>
                            <p class="small">DCCF - 8/18/24</p>
                        </div>
                    </div>
                </div>
            </div>
            

            <div class="tab-pane fade" *ngIf="visibleTabs['therapy']" [class.show]="activeTab === 'therapy'"
                [class.active]="activeTab === 'therapy'" id="nav-therapy" role="tabpanel">
                <h2>Therapy</h2>
                <div>
                    <div>
                        <img src="assets/images/dc-therapy.jpg" alt="DialCare Therapy Logo" class="pull-right float-right d-inline-block" width="200" height="200">
                        <p>DialCare Therapy is designed to provide a safe, secure and private means of seeking mental health assistance from licensed mental health professionals. This unique program offers an app-based interface, virtually connecting members with our mental health professionals not only over the phone but via video session as well. </p>
                        <p>Mental health professionals can assist members with conditions such as depression, anxiety, grief, relationship problems and more.</p>
                        <h3>Therapy is easy to use: </h3>
                        <ul>
                        <li>Members can schedule sessions with a mental health professional from 7 a.m. to 10 p.m. seven days a week. </li>
                        <li>Mental health professionals will reach out via phone or video upon request. </li>
                        <li>Therapy sessions last for 30 minutes. </li>
                        <li>Follow-up sessions may be scheduled at the member's convenience. </li>
                        </ul>
                        <h3>What conditions can DialCare Therapy treat?</h3>
                        <ul>
                        <li>Depression </li>
                        <li>Stress </li>
                        <li>Eating Disorders </li>
                        <li>Addiction </li>
                        <li>Relationship Problems </li>
                        <li>Anxiety </li>
                        <li>Grief </li>
                        <li>And More </li>
                        </ul>
                        <p><strong><em>State availability may vary. Please visit <a href="https://dialcare.com/states" target="_blank" title="This link will open in a new window." rel="noopener noreferrer">dialcare.com/states</a> for up-to-date information.<br>
                        A fee of $95.00 applies to all sessions.<br>
                        Therapy is a part of the DialCare Mental Wellness program.</em></strong></p>
                        <p class="small">DENC - 8/23/24</p>

                        

                    </div>
                </div>
            </div>            
        </div>